import React,{useEffect} from "react";
import styles from "./Footer.module.scss";
import { withRouter } from "react-router-dom";

const Footer = props => {
  useEffect(
    () => {
      //window.onload = function () {
        document.getElementById("container-loader").style.display="none";
      //};
    },
    []
  );

return (
  <footer>
    <div className={styles.footerContainer}>
      <div className={styles.footer}>
        <p>We pay respect to the Traditional Custodians and First Peoples of NSW, and acknowledge their continued
          connection to their country and culture.</p>
        <div className={styles.divider} />
        {/* <ul className={`clearfix`}>
          <li className={styles.item}>Accessibility</li>
          <li className={styles.item}>Privacy</li>
          <li className={styles.item}>Copyright</li>
          <li className={styles.item}>Sitemap</li>
          <li className={styles.item}>Disclaimer</li>
        </ul> */}
        <small className={styles.small}>Copyright © 2021 Department of Customer Service</small>
      </div>
    </div>
  </footer>
)

};
export default withRouter(props => <Footer {...props} />);
